// Types
import type { ComponentType } from 'react'
import type { SvgIconProps } from '@mui/material'
import type { MenuItemIconProps } from '@/types/components/atoms/icon/menu-item'

// Components
// Icons are imported directly (not with dynamic): lazy-loading them when a menu opened suspended the
// whole menu for a moment and made the neighboring header items jump
import ReceiptIconAtom from '@/components/atoms/icon/two-tone/receipt'
import CalendarIconAtom from '@/components/atoms/icon/two-tone/calendar'
import TruckIconAtom from '@/components/atoms/icon/two-tone/truck'
import BuildingsIconAtom from '@/components/atoms/icon/two-tone/buildings'
import ChartIconAtom from '@/components/atoms/icon/two-tone/chart'
import CrownIconAtom from '@/components/atoms/icon/two-tone/crown'
import MagicStarIconAtom from '@/components/atoms/icon/two-tone/magic-star'
import DeviceMessageIconAtom from '@/components/atoms/icon/two-tone/device-message'
import RefreshIconAtom from '@/components/atoms/icon/two-tone/refresh'
import EmojiHappyIconAtom from '@/components/atoms/icon/two-tone/emoji-happy'
import BoxIconAtom from '@/components/atoms/icon/two-tone/box'
import NotificationIconAtom from '@/components/atoms/icon/two-tone/notification'
import MenuBoardIconAtom from '@/components/atoms/icon/two-tone/menu-board'
import ShieldTickIconAtom from '@/components/atoms/icon/two-tone/shield-tick'
import CalculatorIconAtom from '@/components/atoms/icon/two-tone/calculator'
import ScanIconAtom from '@/components/atoms/icon/two-tone/scan'
import GoogleIconAtom from '@/components/atoms/icon/two-tone/google'
import SearchIconAtom from '@/components/atoms/icon/two-tone/search'
import InstagramIconAtom from '@/components/atoms/icon/two-tone/instagram'
import NoteIconAtom from '@/components/atoms/icon/two-tone/note'
import BookIconAtom from '@/components/atoms/icon/two-tone/book'
import MedalIconAtom from '@/components/atoms/icon/two-tone/medal'
import HeadphoneIconAtom from '@/components/atoms/icon/two-tone/headphone'
import DocumentDownloadIconAtom from '@/components/atoms/icon/two-tone/document-download'
import PeopleIconAtom from '@/components/atoms/icon/two-tone/people'
import MessageTextIconAtom from '@/components/atoms/icon/two-tone/message-text'
import InfoIconAtom from '@/components/atoms/icon/two-tone/info'
import CallIconAtom from '@/components/atoms/icon/two-tone/call'
import LinkIconAtom from '@/components/atoms/icon/two-tone/link'
import BriefcaseIconAtom from '@/components/atoms/icon/two-tone/briefcase'
import GlobalIconAtom from '@/components/atoms/icon/two-tone/global'
import CardIconAtom from '@/components/atoms/icon/two-tone/card'
import WalletIconAtom from '@/components/atoms/icon/two-tone/wallet'
import RankingIconAtom from '@/components/atoms/icon/two-tone/ranking'

// Icon for each menu item (the icon key in the locale menu items)
const ITEM_ICONS: Record<string, ComponentType<SvgIconProps>> = {
	receipt: ReceiptIconAtom,
	calendar: CalendarIconAtom,
	truck: TruckIconAtom,
	buildings: BuildingsIconAtom,
	chart: ChartIconAtom,
	crown: CrownIconAtom,
	'magic-star': MagicStarIconAtom,
	'device-message': DeviceMessageIconAtom,
	refresh: RefreshIconAtom,
	'emoji-happy': EmojiHappyIconAtom,
	box: BoxIconAtom,
	notification: NotificationIconAtom,
	'menu-board': MenuBoardIconAtom,
	'shield-tick': ShieldTickIconAtom,
	calculator: CalculatorIconAtom,
	scan: ScanIconAtom,
	google: GoogleIconAtom,
	search: SearchIconAtom,
	instagram: InstagramIconAtom,
	note: NoteIconAtom,
	book: BookIconAtom,
	medal: MedalIconAtom,
	headphone: HeadphoneIconAtom,
	'document-download': DocumentDownloadIconAtom,
	people: PeopleIconAtom,
	'message-text': MessageTextIconAtom,
	info: InfoIconAtom,
	call: CallIconAtom,
	link: LinkIconAtom,
	briefcase: BriefcaseIconAtom,
	global: GlobalIconAtom,
	card: CardIconAtom,
	wallet: WalletIconAtom,
	ranking: RankingIconAtom
}

const MenuItemIconAtom = (props: MenuItemIconProps) => {
	// Props
	const { name } = props

	// Variables
	const Icon = ITEM_ICONS[name]

	return Icon ? <Icon /> : null
}

export default MenuItemIconAtom
